// extracted by mini-css-extract-plugin
module.exports = {"header_chart":"TemperatureChart_header_chart__bACtp","chart":"TemperatureChart_chart__2ST50"};